/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var _default = !!('ontouchstart' in globalObject || globalObject.DocumentTouch && document instanceof DocumentTouch);
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/hasTouch/index.js
// module id = 264
// module chunks = 0